"use client";

import { createContext, useState, useEffect } from "react";

export const ScrollContext = createContext({
  scrollY: 0,
  scrollingUp: false,
  scrollingDown: false,
});

export const ScrollProvider = ({ children }) => {
  const [scrollY, setScrollY] = useState(0);
  const [scrollingUp, setScrollingUp] = useState(false);
  const [scrollingDown, setScrollingDown] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollingUp(currentScrollY < lastScrollY);
      setScrollingDown(currentScrollY > lastScrollY);
      setScrollY(currentScrollY);
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <ScrollContext.Provider value={{ scrollY, scrollingUp, scrollingDown }}>
      {children}
    </ScrollContext.Provider>
  );
};